import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import PopularMarksModels from '../PopularMarksModels/PopularMarksModels';
import s from './CanonicalLinks.css';

class CanonicalLinks extends React.Component {
  static propTypes = {
    canonicalList: PropTypes.arrayOf(PropTypes.shape()),
    transportType: PropTypes.shape().isRequired,
    query: PropTypes.shape(),
    location: PropTypes.shape(),
    linkPrefix: PropTypes.string,
    columnsNum: PropTypes.number,
    //
    intl: intlShape.isRequired,
  };

  static defaultProps = {
    columnsNum: 6,
    canonicalList: null,
    query: {},
    getQuery: {},
    location: null,
    linkPrefix: null,
  };

  state = {
    collapsed: false,
  };

  toggleCollapse = () => {
    this.setState(({ collapsed }) => ({ collapsed: !collapsed }));
  };

  render() {
    const {
      canonicalList,
      query,
      transportType,
      intl,
      location,
      linkPrefix,
      columnsNum,
    } = this.props;

    const { collapsed } = this.state;
    const maxLinkCount = canonicalList && canonicalList.length <= 12 ? 12 : 11;

    const showedBrands =
      canonicalList &&
      canonicalList.map((item, index) => {
        if (collapsed) return { ...item, displayNone: false };
        return { ...item, displayNone: index >= maxLinkCount };
      });

    let collapseBtnText;
    if (!showedBrands || (canonicalList && canonicalList.length <= 12)) {
      collapseBtnText = null;
    } else if (query.make && !collapsed) {
      collapseBtnText = intl.formatMessage({ id: 'Все модели' });
    } else if (!collapsed) {
      collapseBtnText = intl.formatMessage({ id: 'Все марки' });
    } else {
      collapseBtnText = intl.formatMessage({ id: 'Скрыть' });
    }
    const lensEvent = query.make ? 'carModelClick' : 'carMakeClick';

    return (
      <div className={s.root}>
        {showedBrands &&
          showedBrands.length > 0 &&
          <PopularMarksModels
            items={showedBrands}
            linkPrefix={linkPrefix}
            make={query.make}
            category={query.transport_category}
            isNew={query.isNew}
            transportType={transportType}
            columnsNum={columnsNum}
            location={location}
            collapsed={collapsed}
            onCollapseClick={this.toggleCollapse}
            collapseBtnText={collapseBtnText}
            maxLinkCount={maxLinkCount}
            lensEvent={lensEvent}
          />}
      </div>
    );
  }
}

export default withStyles(s)(injectIntl(CanonicalLinks));



// WEBPACK FOOTER //
// ./src/desktop/components/CanonicalLinks/CanonicalLinks.js